import { TodayIcon } from '@blocksuite/icons/rc';

import * as styles from './index.css';

interface RootEmptyProps {
  onClickCreate: () => void;
}

export const RootEmpty = ({ onClickCreate }: RootEmptyProps) => {
  return (
    <div
      className={styles.empty}
      data-testid="navigation-panel-meeting-notes-empty"
    >
      <div className={styles.emptyIcon}>
        <TodayIcon />
      </div>
      <div className={styles.emptyText}>No meeting notes yet</div>
      <button className={styles.emptyButton} onClick={onClickCreate}>
        New Meeting
      </button>
    </div>
  );
};
